import React, { useEffect, useRef, useState } from "react";
import {
  addComments,
  addReply,
  dislikeVideo,
  getComments,
  getFeedbackStatus,
  getReplies,
  getShortVideosRecommendation,
  getVideoDetailsByID,
  getVideoWatchHistory,
  likeVideo,
  reportVideo,
  supportVideo,
} from "../../services/APIServices/videos.api";
import './ShortsContainer.css';
import {
  IconButton,
  Avatar,
  Skeleton,
  Typography,
  Slider,
  Stack,
  TextField,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
} from "@mui/material";
import {
  PlayArrow,
  Pause,
  VolumeOff,
  VolumeUp,
  ThumbUp,
  ThumbDown,
  Comment as CommentIcon,
  Share,
  MoreVert,
  KeyboardBackspace,
  Close,
  Send,
  ReportGmailerrorred,
  Block,
  FavoriteBorder,
} from "@mui/icons-material";
import { RWebShare } from "react-web-share";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getChannelByID, getChannelVideos } from "../../services/APIServices/channel.api";
import { getUserDetails, inscribeChannel } from "../../services/APIServices/user.api";
import { verifyAuth } from "../../services";
import { PAGE_ROUTES, videoUpperLimit } from "../../utils/constants";
import { useAuth } from "../../context/AuthContext";
import { isUserChannel } from "../../utils";
import { getUser } from "../../store/reducers/user.reducer";
import { useAppSelector } from "../../store/hooks";
import { Slide } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { colors } from "../../theme";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Speed, Settings, Info, Report, Check } from "@mui/icons-material";
import { blockChannel, blockVideo } from "../../services/APIServices/block.api";
import { toast } from "react-toastify";
import { getVideoURL, getQualityOptions } from "../../utils/videoQuality";

const ShortVideoFeed = () => {
  const [videos, setVideos] = useState<any[]>([]);
  const [videoIdsFromUI, setVideoIdsFromUI] = useState<string[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [hasNext, setHasNext] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  // let videoID = videos[activeIndex]?.videoID;
  const { channelID, videoID } = useParams();
  const location = useLocation();
  const isShareRoute = location.pathname.includes("/share");
  const isShareRouteByMob = location.pathname.includes("/watch");
  const isChannelRoute = location.pathname.includes("/channel");

  // video state
  const [isPlaying, setIsPlaying] = useState(true);
  const [isGlobalMuted, setIsGlobalMuted] = useState(localStorage.getItem("isGlobalMuted") || false);
  const [videoDetails, setVideoDetails] = useState<any>(null);
  const [channel, setChannel] = useState<any>(null);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [comments, setComments] = useState([]);
  const [replyInput, setReplyInput] = useState(null);
  const [commentInput, setCommentInput] = useState("");
  const [replies, setReplies] = useState([]);
  const inputRef = useRef(null);
  const token = localStorage.getItem('token');
  const theme = useTheme();
  const { t } = useTranslation();

  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [reported, setReported] = useState(false);
  const [supported, setSupported] = useState(false);
  const { verifyAuth, setOnLoginSuccess } = useAuth();
  const [isSpamDialogOpen, setIsSpamDialogOpen] = useState(false);
  const [spamMessage, setSpamMessage] = useState("");
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const speedOptions = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]; // Available speeds
  const [isQualityMenuOpen, setIsQualityMenuOpen] = useState(false);
  const [isDescriptionMenuOpen, setIsDescriptionMenuOpen] = useState(false);
  const [selectedQuality, setSelectedQuality] = useState("Auto");

  const [isSpeedMenuOpen, setIsSpeedMenuOpen] = useState(false);
  const [selectedSpeed, setSelectedSpeed] = useState(1); // Default Speed 1x
  const optionsRef = useRef(null);
  const speedRef = useRef(null);
  const qualityMenuRef = useRef(null);

  const prevVideoIDRef = useRef<string | null>(null);
  const lastReportedTimeRef = useRef<number>(0);

  const videoRefs = useRef<HTMLVideoElement[]>([]);
  const playPauseRef = useRef<HTMLDivElement>(null);
  const commentBoxRef = useRef(null);
  const navigate = useNavigate();
  const user = useAppSelector((state) => getUser(state));

  const [videoHeight, setVideoHeight] = useState(window.innerHeight - 136); // 76 + 60

  useEffect(() => {
    const handleResize = () => {
      const headerHeight = 76;  // AppBar + padding
      const bottomHeight = 60;  // Bottom nav
      setVideoHeight(window.innerHeight - headerHeight - bottomHeight);
    };

    handleResize(); // initialize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // play/pause + fetch video details
  useEffect(() => {
    videoRefs.current.forEach((video, idx) => {
      if (!video) return;
      if (idx === activeIndex) {
        video.play().catch(() => { });
      } else {
        video.pause();
      }
    });

    const fetchDetails = async () => {
      try {
        const videoID = videos[activeIndex]?.videoID;
        if (videoID) {
          const details = (await getVideoDetailsByID(videoID)) as any;
          setVideoDetails(details);

          const channelRes = (await getChannelByID(details?.channelID, user?.userID)) as any;
          setChannel(channelRes);

          await fetchVideoFeedBackDetails(videoID);

          if (!user?.userID) {
            saveWatchedVideoId(videoID);
          } else {
            localStorage.removeItem("watchedVideos");
          }
        }
      } catch (err) {
        console.error("Error fetching video details:", err);
      }
    };

    if (videos[activeIndex]) {
      fetchDetails();
    }
  }, [activeIndex, videos]);

  // 🔹 Fetch initial videos depending on route
  useEffect(() => {
    const fetchInitialVideos = async () => {
      setIsLoading(true);

      const isLoggedIn = !!user;
      let videoIdsFromUI;
      if (!isLoggedIn) {
        const watched = JSON.parse(localStorage.getItem("watchedVideos") || "[]");
        if (watched.length) videoIdsFromUI = watched.join(",");
      }

      try {
        if (isShareRoute || isShareRouteByMob) {
          // single shared video
          if (videoID) {
            const videoDetails = await getVideoDetailsByID(videoID);
            setVideos([videoDetails]);
          }
        } else if (isChannelRoute && channelID) {
          // videos from channel
          const res = await getChannelVideos(channelID);
          if (Array.isArray(res) && res.length > 0) {
            const shortVideos = res.filter((v) => v.videoType === "short");
            const currentVideo = shortVideos.find((v) => v.videoID === videoID);
            const others = shortVideos.filter((v) => v.videoID !== videoID);
            const sorted = currentVideo ? [currentVideo, ...others] : shortVideos;
            setVideos(sorted);
          }
        } else if (videoID) {
          // single clicked short
          const videoDetails = await getVideoDetailsByID(videoID);
          setVideos([videoDetails]);
          const recs = (await getShortVideosRecommendation({
            lowerLimit: 0,
            upperLimit: videoUpperLimit,
            userID: user?.userID,
            videotype: "short",
            videoIdsFromUI,
          })) as any;
          const filtered = recs.filter((v: any) => v.videoID !== videoID);
          setVideos((prev) => [...prev, ...filtered]);
          setHasNext(recs.length >= videoUpperLimit);
        } else {
          // default feed
          const res = (await getShortVideosRecommendation({
            lowerLimit: 0,
            upperLimit: videoUpperLimit,
            userID: user?.userID,
            videotype: "short",
            videoIdsFromUI,
          })) as any;
          setVideos(res);
          setHasNext(res.length >= videoUpperLimit);
        }
      } catch (err) {
        console.error("Error fetching initial videos:", err);
      } finally {
        setIsLoading(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    fetchInitialVideos();
  }, [channelID, videoID]);

  // 🔹 Load more videos when scrolling near end
  const fetchMoreVideos = async () => {
    if (isLoading || !hasNext) return;
    setIsLoading(true);

    const isLoggedIn = !!user;
    let videoIdsFromUI;
    if (!isLoggedIn) {
      const watched = JSON.parse(localStorage.getItem("watchedVideos") || "[]");
      if (watched.length) videoIdsFromUI = watched.join(",");
    }

    try {
      const res = await getShortVideosRecommendation({
        lowerLimit: videos.length,
        upperLimit: videos.length + videoUpperLimit,
        userID: user?.userID,
        videotype: "short",
        videoIdsFromUI,
      });
      if (Array.isArray(res) && res.length > 0) {
        setVideos((prev) => [...prev, ...res]);
        setHasNext(res.length >= videoUpperLimit);
      } else {
        setHasNext(false);
      }
    } catch (err) {
      console.error("Error fetching more videos:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // scroll/swipe
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const container = e.currentTarget;
    const index = Math.round(container.scrollTop / videoHeight);
    setActiveIndex(index);

    if (index >= videos.length - 3) {
      fetchMoreVideos();
    }
  };

  const formatNumber = (value: number | undefined, suffix: string) => {
    if (value === undefined) return `0 ${suffix}`;
    if (value >= 1e9) return `${(value / 1e9).toFixed(1)}B ${suffix}`;
    if (value >= 1e6) return `${(value / 1e6).toFixed(1)}M ${suffix}`;
    if (value >= 1e3) return `${(value / 1e3).toFixed(1)}K ${suffix}`;
    return `${value} ${suffix}`;
  }

  const fetchVideoFeedBackDetails = async (videoID: string) => {
    console.log("Fetching feedback for videoID:", videoID, "userID:", user?.userID, "user:", user);
    if (!user?.userID || !videoID) return;
    try {
      const feedbackStatus = (await getFeedbackStatus(user.userID, videoID)) as any;
      setLiked(feedbackStatus.like || false);
      setDisliked(feedbackStatus.dislike || false);
      setReported(feedbackStatus.spam || false);
      setSupported(feedbackStatus.support || false);
    } catch (error) {
      console.error("Error fetching video feedback:", error);
    }
  };

  const handleInscribe = () => {
    inscribeChannel(channel?.channelID, user?.userID).then(
      (res: any) => {
        let status = res?.message?.split(" ")?.[0];
        if (status && channel) {
          getChannelByID(videoDetails?.channelID, user?.userID).then(
            (res) => {
              setChannel(res);
            }
          );
        }
      }
    );
  };

  const handleSubscribeClick = () => {
    if (verifyAuth()) {
      handleInscribe();
    } else {
      setOnLoginSuccess(handleInscribe);
    }
  };

  const handleDislike = () => {
    dislikeVideo(user?.userID, videoDetails?.videoID).then(
      (res: any) => {
        fetchVideoFeedBackDetails(videoDetails?.videoID);
        getVideoDetailsByID(videoDetails?.videoID).then(
          (res) => {
            setVideoDetails(res);
          }
        );
      }
    );
  };

  const handleDislikeClick = () => {
    if (verifyAuth()) {
      handleDislike();
    } else {
      setOnLoginSuccess(handleDislike);
    }
  };
  const handleSpam = () => {
    reportVideo(user?.userID, videoDetails?.videoID, spamMessage).then(
      (res: any) => {
        fetchVideoFeedBackDetails(videoDetails?.videoID);
        getVideoDetailsByID(videoDetails?.videoID).then((res) => {
          setVideoDetails(res);
          setSpamMessage(""); // Clear the input
          setIsSpamDialogOpen(false); // Close the popup
        });
      }
    );
  };
  const handleSpamClick = () => {
    setIsOptionsOpen(false);
    if (verifyAuth()) {
      setIsSpamDialogOpen(true);
    } else {
      setOnLoginSuccess(() => setIsSpamDialogOpen(true));
    }
  };

  const handleLike = () => {
    likeVideo(user?.userID, videoDetails?.videoID).then(
      (res) => {
        fetchVideoFeedBackDetails(videoDetails?.videoID);
        getVideoDetailsByID(videoDetails?.videoID).then(
          (res) => {
            setVideoDetails(res);
          }
        );
      }
    );
  };
  const handleLikeClick = () => {
    if (verifyAuth()) {
      handleLike();
    } else {
      setOnLoginSuccess(handleLike);
    }
  };

  const handleSupport = () => {
    const watchTimeSeconds = Math.floor(currentTime);
    supportVideo(user?.userID as string, videos[activeIndex]?.videoID as string, watchTimeSeconds).then(
      (res: any) => {
        fetchVideoFeedBackDetails(videos[activeIndex]?.videoID);
      }
    );
  };

  const handleSupportClick = () => {
    if (verifyAuth()) {
      handleSupport();
    } else {
      setOnLoginSuccess(handleSupport);
    }
  };

  const handleChannelClick = () => {
    if (channel?.channelID) {
      navigate(`${PAGE_ROUTES.CHANNEL_PAGE}/profile/${channel?.channelID}`);
    }
  };

  useEffect(() => {
    const container = document.querySelector(".short-container");
    console.log("isOpen changed:", isOpen, "container:", container);

    if (isOpen && container) {
      (container as HTMLElement).style.overflow = "hidden";
    } else if (container) {
      (container as HTMLElement).style.overflow = "auto";
    }

    return () => {
      if (container) (container as HTMLElement).style.overflow = "auto";
    };
  }, [isOpen]);

  useEffect(() => {
    const videoID = videos[activeIndex]?.videoID;
    if (videoID) {
      getComments(videoID, 0, 10).then(async (res: any) => {
        if (!res) return;

        // ✅ Fetch user details for each comment and update response
        const updatedComments = (await Promise.all(
          res.map(async (comment: any) => {
            let userRes = null;
            if (user?.userID) {
              userRes = (await getUserDetails(comment.userID)) as any;
            }
            return {
              ...comment,
              profilePic: userRes?.profilePic || "", // ✅ Add profilePic field
              formattedTime: new Date(comment.creationTime).toLocaleString(), // ✅ Format timestamp
            };
          })
        )) as any;

        setComments(updatedComments); // ✅ Set updated comments
      });
    }
  }, [activeIndex, videos]);

  const handleComment = () => {
    let videoID = videos[activeIndex]?.videoID;
    if (commentInput && videoID) {
      if (replyView) {
        addReply(commentInput, user?.userID, videoID, replyView?.commentID).then(() => {
          getReplies(replyView?.commentID, 0, 10).then(async (res: any) => {
            // ✅ Fetch user details for each reply and update the response
            const updatedReplies = (await Promise.all(
              res.map(async (reply: any) => {
                let userRes = null;
                if (user?.userID) {
                  userRes = (await getUserDetails(reply.userID)) as any;
                }

                return {
                  ...reply,
                  profilePic: userRes?.profilePic || "", // ✅ Add profilePic field
                  formattedTime: new Date(reply.creationTime).toLocaleString(), // ✅ Format timestamp
                };
              })
            )) as any;
            setReplies(updatedReplies);
            // setReplies((prev) => ({ ...prev, [replyView?.commentID]: updatedReplies }));
          });
        });
      } else {
        addComments(commentInput, user?.userID, videoID).then(() => {
          getComments(videoID, 0, 10).then(async (res: any) => {
            // ✅ Fetch user details for each new comment and update response
            const updatedComments = (await Promise.all(
              res.map(async (comment: any) => {
                let userRes = null;
                if (user?.userID) {
                  userRes = (await getUserDetails(comment.userID)) as any;
                }
                return {
                  ...comment,
                  profilePic: userRes?.profilePic || "", // ✅ Add profilePic field
                  formattedTime: new Date(comment.creationTime).toLocaleString(), // ✅ Format timestamp
                };
              })
            )) as any;

            setComments(updatedComments); // ✅ Set updated comments
          });
        });
      }
      setCommentInput("");
      setReplyInput(null);
    }
  };

  type ReplyViewType = {
    commentID: string;
    userName?: string;
    profilePic?: string;
    message?: string;
    creationTime?: string;
    repiesCount?: number;
    // add other properties if needed
  };

  const [replyView, setReplyView] = useState<ReplyViewType | null>(null);

  const fetchReplies = async (commentID: any) => {
    try {
      const res = (await getReplies(commentID)) as any;
      const updatedReplies = (await Promise.all(
        res.map(async (reply: any) => {
          let userRes = null;
          if (user?.userID) {
            userRes = (await getUserDetails(reply.userID)) as any;
          }
          return {
            ...reply,
            profilePic: userRes?.profilePic || "", // Add profilePic
            formattedTime: new Date(reply.creationTime).toLocaleString(), // Format time
          };
        })
      )) as any;
      setReplies(updatedReplies);
    } catch (error) {
      console.error("Error fetching replies:", error);
    }
  };

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        commentBoxRef.current &&
        !(commentBoxRef.current as HTMLElement).contains(event.target)
      ) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (optionsRef.current && !(optionsRef.current as HTMLElement).contains(event.target)) {
        setIsOptionsOpen(false); // Close options popup
      }
    }

    if (isOptionsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen]);

  // Close popup on outside click
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (speedRef.current && !(speedRef.current as HTMLElement).contains(event.target)) {
        setIsOptionsOpen(false);
        setIsSpeedMenuOpen(false);
      }
    }

    if (isOptionsOpen || isSpeedMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen, isSpeedMenuOpen]);

  // Close popup on outside click
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (qualityMenuRef.current && !(qualityMenuRef.current as HTMLElement).contains(event.target)) {
        setIsOptionsOpen(false);
        setIsQualityMenuOpen(false);
      }
    }

    if (isOptionsOpen || isQualityMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen, isQualityMenuOpen]);

  const descriptionMenuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (descriptionMenuRef.current && !(descriptionMenuRef.current as HTMLElement).contains(event.target)) {
        setIsOptionsOpen(false);
        setIsDescriptionMenuOpen(false);
      }
    }

    if (isOptionsOpen || isDescriptionMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen, isDescriptionMenuOpen]);


  const handleSpeedChange = (speed: any) => {
    setSelectedSpeed(speed);
    const activeVideo = videoRefs.current[activeIndex];
    if (activeVideo) {
      activeVideo.playbackRate = speed; // Update video playback speed
    }
    setIsSpeedMenuOpen(false); // Close speed menu
  };

  const handleQualityChange = (q: any) => {
    const activeVideo = videoRefs.current[activeIndex];
    if (activeVideo) {
      const current = activeVideo.currentTime; // Get current time for short video
      setCurrentTime(current); // Set current time to state
      setSelectedQuality(q);
      setIsQualityMenuOpen(false);
      setTimeout(() => {
        if (videoRefs.current[activeIndex]) {
          videoRefs.current[activeIndex].currentTime = current;
          videoRefs.current[activeIndex].play().catch((err: any) => console.error("Play error:", err));
        }
      }, 50); // Short delay before seeking
    }
  };

  const saveWatchedVideoId = (videoID: any) => {
    const watched = JSON.parse(localStorage.getItem("watchedVideos") || "[]");
    if (!watched.includes(videoID)) {
      watched.push(videoID);
      localStorage.setItem("watchedVideos", JSON.stringify(watched));
    }
  };

  useEffect(() => {
    document.querySelectorAll("video").forEach((vid: any) => {
      vid.muted = isGlobalMuted;
    });
  }, [isGlobalMuted]);

  // 🧠 Debounced save function — run only once when needed
  const saveWatchProgress = async (id: string, time: number, dur: number) => {
    if (!id || time <= 0 || dur <= 0) return;
    try {
      await getVideoWatchHistory(id, Math.floor(time), Math.floor(dur));
      console.log("Watch progress updated for:", id, time, "/", dur);
    } catch (err) {
      console.error("Error updating watch progress", err);
    }
  };

  // ✅ When user scrolls to new video (old → new)
  useEffect(() => {
    const activeVideo = videos[activeIndex];
    const newVideoID = activeVideo?.videoID;

    if (
      prevVideoIDRef.current &&
      prevVideoIDRef.current !== newVideoID &&
      lastReportedTimeRef.current > 0 &&
      duration > 0
    ) {
      console.log("Saving previous short progress");
      saveWatchProgress(
        prevVideoIDRef.current,
        lastReportedTimeRef.current,
        duration
      );
    }

    prevVideoIDRef.current = newVideoID ?? null;
    lastReportedTimeRef.current = 0;
  }, [activeIndex]);

  // ✅ On component unmount
  useEffect(() => {
    return () => {
      if (
        prevVideoIDRef.current &&
        lastReportedTimeRef.current > 0 &&
        duration > 0
      ) {
        console.log("Shorts unmount — saving progress");
        saveWatchProgress(
          prevVideoIDRef.current,
          lastReportedTimeRef.current,
          duration
        );
      }
    };
  }, []);

  const handleBlockChannel = async (channelID: string) => {
    if (!verifyAuth()) {
      setOnLoginSuccess(() => handleBlockChannel(channelID));
      return;
    }
    try {
      await blockChannel(channelID);
      toast.success("Channel blocked successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to block channel");
    }
  };

  const handleBlockVideo = async (videoID: string) => {
    if (!verifyAuth()) {
      setOnLoginSuccess(() => handleBlockVideo(videoID));
      return;
    }

    try {
      const updated = videos.filter((v: any) => v.videoID !== videoID);
      videos.length = 0;
      videos.push(...updated);

      await blockVideo(videoID);

      toast.success("Video blocked successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to block video");
    }
  };

  const handleReport = (video: any) => {
    if (verifyAuth()) {
      setSelectedReason("");
      setCustomReason("");
      setIsReportDialogOpen(true);
    } else {
      setOnLoginSuccess(() => handleReport(video));
    }
  };

  const handleReportSubmit = (video: any) => {
    try {
      if (!selectedReason) {
        toast.warning("Please select a reason before submitting.");
        return;
      }

      const reason =
        selectedReason === "Other" && customReason.trim()
          ? `Other: ${customReason.trim()}`
          : selectedReason;

      const supportEmail = "contact@indeeclips.com";
      const subject = "Video Report";
      const body = [
        "Hello IndeeClips Team,",
        "",
        "I found an issue with the following video on the platform:",
        "",
        `Video Title: ${video?.title || "N/A"}`,
        `Channel Name: ${video?.channelName || "N/A"}`,
        `Reported Reason: ${reason}`,
        "",
        "Kindly look into this matter at the earliest and take the necessary action.",
        "",
        `Thanks & Regards,`,
        `${user?.email || "IndeeClips User"}`
      ].join("\n");

      const encodedSubject = encodeURIComponent(subject);
      const encodedBody = encodeURIComponent(body);

      const isMobile = /Android|iPhone|iPad|iPod/i.test(
        navigator.userAgent || ""
      );

      if (isMobile) {
        window.location.href = `mailto:${supportEmail}?subject=${encodedSubject}&body=${encodedBody}`;
      } else {
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=${encodedSubject}&body=${encodedBody}`;
        window.open(gmailUrl, "_blank", "noopener,noreferrer");
      }

      setIsReportDialogOpen(false);
      toast.success("Redirecting to email...");
    } catch (error) {
      console.error("Error while reporting video:", error);
      toast.error("Failed to open email. Please try again.");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        overflowY: isOpen ? "hidden" : "scroll",
        scrollSnapType: "y mandatory",
      }}
      onScroll={handleScroll}
    >
      {videos.map((short, idx) => {
        const isActive = idx === activeIndex;
        const videoRef = videoRefs.current[idx];

        return (
          <div
            key={short.videoID}
            style={{
              height: `${videoHeight}px`,
              width: "100%",
              position: "relative",
              scrollSnapAlign: "start",
              background: "black",
              marginBottom: "20px",
            }}
          >

            {videoDetails && user && videoDetails?.age >= 18 && user?.age < 18 ? (
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                bgcolor="rgba(0, 0, 0, 0.8)"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                color="white"
                textAlign="center"
                zIndex={10}
              >
                <Typography variant="body2" padding={2}>
                  {t("ageRestrictedClips")}
                </Typography>
              </Box>
            ) : videoDetails && videoDetails?.deleted ? (
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                bgcolor="rgb(0, 0, 0)"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                color="white"
                textAlign="center"
                zIndex={10}
              >
                <Typography variant="body2">{t("clipDeletedMessage")}</Typography>
              </Box>
            ) : null}


            <video
              ref={(el) => {
                if (el) videoRefs.current[idx] = el;
              }}
              src={getVideoURL(
                process.env.REACT_APP_SERVER_URL!,
                short.videoID,
                short.hlsProcessed || false,
                selectedQuality
              )}
              playsInline
              muted={Boolean(isGlobalMuted)}
              loop
              onLoadedMetadata={(e) => setDuration(e.currentTarget.duration)}
              onTimeUpdate={(e) => {
                const playedSeconds = e.currentTarget.currentTime;
                setCurrentTime(playedSeconds);

                if (playedSeconds - lastReportedTimeRef.current >= 5) {
                  lastReportedTimeRef.current = playedSeconds;
                }
              }}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              autoPlay={isActive}
            />

            {/* controls */}
            {isActive && (
              <>
                <div className="controls" style={{ position: "absolute", top: 10 }}>
                  <IconButton
                    onClick={() => {
                      navigate("/");
                    }}
                    sx={{ color: "#fff" }}
                  >
                    <KeyboardBackspace />
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      if (!isPlaying) {
                        videoRef?.play().catch(() => { });
                        setIsPlaying(true);
                      } else {
                        videoRef?.pause();
                        setIsPlaying(false);
                      }
                    }}
                    sx={{ color: "#fff" }}
                  >
                    {isPlaying ? <Pause /> : <PlayArrow />}
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      setIsGlobalMuted((prev) => !prev);
                      localStorage.setItem("isGlobalMuted", String(!isGlobalMuted));
                    }}
                    sx={{ color: "#fff" }}
                  >
                    {isGlobalMuted ? <VolumeOff /> : <VolumeUp />}
                  </IconButton>
                </div>


                {/* tap to play */}
                <div
                  ref={playPauseRef}
                  onClick={() => {
                    if (isPlaying) {
                      videoRef?.pause();
                      setIsPlaying(false);
                    } else {
                      videoRef?.play().catch(() => { });
                      setIsPlaying(true);
                    }
                  }}
                  className={`play-pause ${isPlaying ? "" : "show-play-pause"}`}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "white",
                    fontSize: "50px",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                >
                  <PlayArrow />
                </div>


                {/* right reactions */}
                <div
                  className="reaction"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "55%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  {/* Support Button */}
                  <div>
                    <IconButton
                      onClick={() => {
                        if (currentTime >= 60) {
                          handleSupportClick();
                        }
                      }}
                      disabled={
                        currentTime < 60 ||
                        isUserChannel(user?.channelList, channel?.channelID)
                      }
                      sx={{
                        color: supported ? "#027fff" : "white",
                        opacity: currentTime < 60 ? 0.5 : 1,
                        cursor: currentTime < 60 ? "not-allowed" : "pointer",
                        "&.Mui-disabled": {
                          color: "white",
                        },
                      }}
                    >
                      <FavoriteBorder />
                    </IconButton>
                    <Typography sx={{ fontSize: "10px", color: "#fff", textAlign: "center" }}>
                      {t("support")}
                    </Typography>
                  </div>

                  <div>
                    <IconButton
                      onClick={handleLikeClick}
                      disabled={isUserChannel(user?.channelList, channel?.channelID)}
                      sx={{
                        color: liked ? "#027fff" : "white",
                        "&.Mui-disabled": {
                          color: "white",
                        },
                      }}
                    >
                      <ThumbUp />
                    </IconButton>
                    <Typography sx={{ fontSize: "10px", color: "#fff", textAlign: "center" }}>
                      {formatNumber(videoDetails?.likes, "")}
                    </Typography>
                  </div>

                  <div>
                    <IconButton
                      onClick={handleDislikeClick}
                      disabled={isUserChannel(user?.channelList, channel?.channelID)}
                      sx={{
                        color: disliked ? "#027fff" : "white",
                        "&.Mui-disabled": {
                          color: "white",
                        },
                      }}
                    >
                      <ThumbDown />
                    </IconButton>
                    <Typography sx={{ fontSize: "10px", color: "#fff", textAlign: "center" }}>
                      {formatNumber(videoDetails?.disLikes, "")}
                    </Typography>
                  </div>

                  <div>
                    <IconButton onClick={() => setIsOpen(!isOpen)} sx={{ color: "#fff" }}>
                      <CommentIcon />
                    </IconButton>
                  </div>

                  {/* Share Button */}
                  <div style={{ zIndex: 13000 }}>
                    <RWebShare
                      data={{
                        text: videoDetails?.description,
                        url: `${window.location.origin}/watch/${videoDetails?.videoID}?type=clip`,
                        title: videoDetails?.title,
                      }}
                    >
                      <IconButton
                        sx={{ color: "#fff" }}>
                        <Share />
                      </IconButton>
                    </RWebShare>
                  </div>

                  <IconButton onClick={() => setIsOptionsOpen(true)} sx={{ color: "white" }}>
                    <MoreVert />
                  </IconButton>
                </div>

                {/* footer */}
                <div
                  className="foot"
                  style={{
                    position: "absolute",
                    bottom: 10,
                    left: 10,
                    right: 10,
                    color: "white",
                  }}
                >
                  <div
                    className="user-info"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <Avatar
                      sx={{ width: 35, height: 35 }}
                      src={channel?.profilePic}
                      alt={channel?.name}
                      onClick={handleChannelClick}
                    />
                    <span onClick={handleChannelClick}>{channel?.name ? channel.name : <Skeleton width={100} height={20} />}</span>
                    <button
                      onClick={isUserChannel(user?.channelList, channel?.channelID) ? () => { } : handleSubscribeClick}
                      disabled={isUserChannel(user?.channelList, channel?.channelID)}
                      style={{
                        backgroundColor: isUserChannel(user?.channelList, channel?.channelID) ? "grey" : "#FF5722", // Orange for others, grey for own channel
                        cursor: isUserChannel(user?.channelList, channel?.channelID) ? "not-allowed" : "pointer",
                        color: "white",
                      }}
                    >
                      {channel?.isSubscribed === true || channel?.isSubscribed === "SUBSCRIBED"
                        ? "Unsubscribe"
                        : "Subscribe"}
                    </button>
                  </div>
                  <div className="title">{short?.title || <Skeleton width="60%" height={20} />}</div>
                </div>

                <div className="progress-bar-container">
                  {/* progress bar */}
                  <Slider
                    value={(currentTime / duration) * 100 || 0}
                    onChange={(_, value) => {
                      if (videoRef) {
                        videoRef.currentTime = ((value as number) / 100) * duration;
                      }
                    }}
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      color: "blue",
                      height: 4,
                      "& .MuiSlider-track": { backgroundColor: "blue" },
                      "& .MuiSlider-rail": { backgroundColor: "white", opacity: 1 },
                      "& .MuiSlider-thumb": { display: "none" },
                    }}
                  />
                </div>
              </>
            )}
          </div>
        );
      })}
      {isLoading && <div style={{ textAlign: "center" }}>
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{ transform: "translate(-50%, -50%)" }}
        >
          <CircularProgress sx={{ color: "blue" }} />
        </Box>
      </div>}

      <Slide direction="up" in={isOpen} mountOnEnter unmountOnExit>
        <div
          ref={commentBoxRef}
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "50vh",
            background: theme.palette.mode === "dark" ? "black" : "white",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            padding: "10px",
            overflowY: "auto",
            zIndex: 2000, // upar rahe sabse
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Sticky Header */}
          <div
            style={{
              position: "sticky",
              top: 0,
              background: theme.palette.mode === "dark" ? "black" : "white",
              paddingBottom: "5px",
              zIndex: 10,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" style={{ fontSize: "18px" }}>
              {t("comments")}
            </Typography>
            <IconButton onClick={() => setIsOpen(false)}>
              <Close />
            </IconButton>
          </div>

          {/* ✅ Yaha tu ka pura comments/replies wala code use kar le (jo tu ne bheja hai) */}
          <div style={{ flex: 1, overflowY: "auto" }}>
            {replyView ? (
              <>
                {/* Original Comment with Close Icon */}
                <Stack direction="row" spacing={2} alignItems="center" paddingBottom={1} borderBottom="1px solid #ddd">
                  <Avatar src={replyView.profilePic} alt={replyView.userName} />
                  <Stack>
                    <Typography variant="subtitle2" style={{ fontSize: "14px" }}>{replyView.userName}</Typography>
                    <Typography variant="body2" style={{ fontSize: "12px", color: "#555" }}>{replyView.message}</Typography>
                  </Stack>
                  <IconButton onClick={() => setReplyView(null)}>
                    <Close />
                  </IconButton>
                </Stack>
                {replies.length === 0 ? (
                  <Typography variant="body2" marginTop={1} style={{ fontSize: "12px" }}>
                    {t("noReplies")}
                  </Typography>
                ) : (
                  replies.map((reply: any) => (
                    <Stack key={reply.commentID} direction="row" spacing={2} alignItems="center" marginBottom={1} marginLeft={1}>
                      <Avatar src={reply.profilePic} alt={reply.userName} /> {/* Profile Picture */}
                      <Stack>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography variant="subtitle2" style={{ fontSize: "12px" }}>{reply.userName}</Typography>
                          <Typography variant="caption" color="textSecondary" style={{ fontSize: "10px" }}>
                            &nbsp;{`• ${moment(
                              `${reply?.creationTime?.split("T")?.join(" ")} UTC`
                            ).fromNow()}`}
                          </Typography>
                        </Stack>
                        <Typography variant="body2" style={{ fontSize: "12px", color: "#555" }}>
                          {reply.message}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="primary"
                          style={{ cursor: "pointer", fontSize: "12px" }}
                          onClick={() => { setReplyView(reply); fetchReplies(reply.commentID); }}
                        >
                          {t("replies", { count: reply.repiesCount })}
                        </Typography>
                      </Stack>
                    </Stack>
                  ))
                )}

              </>
            ) : (
              <>
                {/* Main Comments List */}
                {comments.length === 0 ? (
                  <Typography variant="body2" style={{ fontSize: "12px" }}>{t("noComments")}</Typography>
                ) : (
                  comments.map((cmt: any) => (
                    <Stack key={cmt.commentID} direction="column" spacing={1} marginBottom={1}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar src={cmt.profilePic} alt={cmt.userName} />
                        <Stack>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="subtitle2" style={{ fontSize: "14px" }}>{cmt.userName}</Typography>
                            <Typography variant="caption" color="textSecondary" style={{ fontSize: "10px" }}>
                              &nbsp;{`• ${moment(
                                `${cmt?.creationTime?.split("T")?.join(" ")} UTC`
                              ).fromNow()}`}
                            </Typography>
                          </Stack>
                          <Typography variant="body2" style={{ fontSize: "12px", color: "#555" }}>{cmt.message}</Typography>
                          <Typography
                            variant="caption"
                            color="primary"
                            style={{ cursor: "pointer", fontSize: "12px" }}
                            onClick={() => {
                              setReplyView(cmt);
                              fetchReplies(cmt.commentID); // ✅ Fetch Replies when clicking
                            }}
                          >
                            {t("replies", { count: cmt?.repiesCount })}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  ))
                )}
              </>
            )}
          </div>

          {/* Sticky Input Box */}
          <div
            style={{
              position: "sticky",
              bottom: 0,
              background: theme.palette.mode === "dark" ? "black" : "white",
              paddingTop: "5px",
              zIndex: 10,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {token ? (
                <>
                  <TextField
                    inputRef={inputRef}
                    value={commentInput}
                    onChange={(e) => setCommentInput(e.target.value)}
                    placeholder={replyView ? `Reply to ${replyView.userName}` : "Add a comment"}
                    fullWidth
                    size="small"
                    style={{ fontSize: "12px" }}
                  />
                  <IconButton onClick={handleComment} color="primary">
                    <Send />
                  </IconButton>
                </>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  {t("please")}{" "}
                  <span
                    onClick={() => verifyAuth()}
                    style={{ cursor: "pointer", color: colors.blueDark }}
                  >
                    {t("login")}
                  </span>{" "}
                  {t("toAddComment")}
                </Typography>
              )}
            </Stack>
          </div>
        </div>
      </Slide>

      {/* More Options Bottom Slide */}
      <Slide direction="up" in={isOptionsOpen} mountOnEnter unmountOnExit>
        <div
          ref={optionsRef}
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            background: theme.palette.mode === "dark" ? "black" : "white",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            padding: 10,
            maxHeight: "50vh",
            overflowY: "auto",
            zIndex: 2000,
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
          }}
        >
          {/* Header */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" paddingBottom={1} borderBottom="1px solid #ddd">
            <Typography variant="h6" style={{ fontSize: "16px" }}>{t('options')}</Typography>
            <IconButton onClick={() => setIsOptionsOpen(false)}>
              <Close />
            </IconButton>
          </Stack>

          {/* Option Items */}
          <Stack spacing={2} marginTop={2}>
            <Stack direction="row" alignItems="center" spacing={2} onClick={() => setIsSpeedMenuOpen(true)} style={{ cursor: "pointer" }}>
              <Speed sx={{ color: "#555" }} />
              <Typography variant="body1" style={{ fontSize: "14px" }}>{t("playbackSpeed")}</Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={2} onClick={() => { setIsOptionsOpen(false); setIsQualityMenuOpen(true); }} style={{ cursor: "pointer" }}>
              <Settings sx={{ color: "#555" }} />
              <Typography variant="body1" style={{ fontSize: "14px" }}>{t("quality")}</Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={2} onClick={() => setIsDescriptionMenuOpen(true)} style={{ cursor: "pointer" }}>
              <Info sx={{ color: "#555" }} />
              <Typography variant="body1" style={{ fontSize: "14px" }}>{t("description")}</Typography>
            </Stack>

            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{
                cursor: isUserChannel(user?.channelList, channel?.channelID) ? 'not-allowed' : 'pointer',
                color: isUserChannel(user?.channelList, channel?.channelID) ? 'grey' : reported ? 'blue' : 'default',
              }}
              onClick={isUserChannel(user?.channelList, channel?.channelID) ? () => { } : handleSpamClick}
            >
              <Report sx={{ color: isUserChannel(user?.channelList, channel?.channelID) ? 'grey' : reported ? 'blue' : 'default', }} />
              <Typography variant="body1" style={{ fontSize: "14px" }}>{t("spam")}</Typography>
            </Stack>

            {/* Report */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              onClick={() => {
                setIsOptionsOpen(false);
                handleReport(videoDetails);
              }}
              style={{ cursor: "pointer" }}
            >
              <ReportGmailerrorred sx={{ color: "#e53935" }} />
              <Typography variant="body1" style={{ fontSize: "14px" }}>
                {t("videoCard.report")}
              </Typography>
            </Stack>

            {/* Block Video */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              onClick={() => {
                handleBlockVideo(videoDetails?.videoID);
                setIsOptionsOpen(false);
              }}
              style={{ cursor: "pointer" }}
            >
              <Block sx={{ color: "#555" }} />
              <Typography variant="body1" style={{ fontSize: "14px" }}>
                {t("videoCard.blockVideo")}
              </Typography>
            </Stack>

            {/* Block Channel */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              onClick={() => {
                handleBlockChannel(channel?.channelID || "");
                setIsOptionsOpen(false);
              }}
              style={{ cursor: "pointer" }}
            >
              <Block sx={{ color: "#555" }} />
              <Typography variant="body1" style={{ fontSize: "14px" }}>
                {t("videoCard.blockChannel")}
              </Typography>
            </Stack>
          </Stack>
        </div>
      </Slide>

      {/* Playback Speed Bottom Slide */}
      <Slide direction="up" in={isSpeedMenuOpen} mountOnEnter unmountOnExit>
        <div
          ref={speedRef}
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            background: theme.palette.mode === "dark" ? "black" : "white",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            padding: 10,
            maxHeight: "50vh",
            overflowY: "auto",
            zIndex: 2000,
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
          }}
        >
          {/* Header */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" paddingBottom={1} borderBottom="1px solid #ddd">
            <Typography variant="h6" style={{ fontSize: "16px" }}>{t("playbackSpeed")}</Typography>
            <IconButton onClick={() => setIsSpeedMenuOpen(false)}>
              <Close />
            </IconButton>
          </Stack>

          {/* Speed Options */}
          <Stack spacing={2} marginTop={2}>
            {speedOptions.map((speed) => (
              <Stack
                key={speed}
                direction="row"
                alignItems="center"
                spacing={2}
                style={{ cursor: "pointer" }}
                onClick={() => handleSpeedChange(speed)}
              >
                {selectedSpeed === speed && <Check sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }} />}
                <Typography variant="body1" style={{ fontSize: "14px", fontWeight: selectedSpeed === speed ? "bold" : "normal" }}>
                  {speed}x {speed === 1 ? "(normal)" : ""}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </div>
      </Slide>

      {/* Quality Bottom Slide */}
      <Slide direction="up" in={isQualityMenuOpen} mountOnEnter unmountOnExit>
        <div
          ref={qualityMenuRef}
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            background: theme.palette.mode === "dark" ? "black" : "white",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            padding: 10,
            maxHeight: "50vh",
            overflowY: "auto",
            zIndex: 2000,
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
          }}
        >
          {/* Header */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" paddingBottom={1} borderBottom="1px solid #ddd">
            <Typography variant="h6" style={{ fontSize: "16px" }}>{t("quality")}</Typography>
            <IconButton onClick={() => setIsQualityMenuOpen(false)}>
              <Close />
            </IconButton>
          </Stack>

          {/* Quality Options */}
          {getQualityOptions().map((quality) => (
            <Stack
              key={quality}
              direction="row"
              alignItems="center"
              spacing={1}
              padding="10px"
              onClick={() => handleQualityChange(quality)}
              sx={{ cursor: "pointer" }}
            >
              {selectedQuality === quality && <Check sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }} />}
              <Typography variant="body1" style={{ fontSize: "14px", fontWeight: selectedQuality === quality ? "bold" : "normal" }}>
                {quality}
              </Typography>
            </Stack>
          ))}
        </div>
      </Slide>

      {/* Description Bottom Slide */}
      <Slide direction="up" in={isDescriptionMenuOpen} mountOnEnter unmountOnExit>
        <div
          ref={descriptionMenuRef}
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            background: theme.palette.mode === "dark" ? "black" : "white",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            padding: 10,
            maxHeight: "50vh",
            height: "50vh",
            overflowY: "auto",
            zIndex: 2000,
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
          }}
        >
          {/* Header */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" paddingBottom={1} borderBottom="1px solid #ddd">
            <Typography variant="h6" style={{ fontSize: "16px" }}>{t("description")}</Typography>
            <IconButton onClick={() => setIsDescriptionMenuOpen(false)}>
              <Close />
            </IconButton>
          </Stack>

          {/* Description Content */}
          <Typography variant="body1" style={{ fontSize: "14px", padding: "10px", whiteSpace: "pre-wrap" }}>
            {videoDetails?.description}
          </Typography>
        </div>
      </Slide>
      
      {/* Report Dialog */}
      <Dialog open={isReportDialogOpen} onClose={() => setIsReportDialogOpen(false)}>
        <DialogTitle>{t("reportDialog.title")}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {t("reportDialog.description")}
          </Typography>

          <TextField
            select
            fullWidth
            label={t("reportDialog.selectReasonLabel")}
            value={selectedReason}
            onChange={(e) => setSelectedReason(e.target.value)}
            sx={{ mb: selectedReason === "Other" ? 2 : 0 }}
          >
            {(t("reportDialog.reasons", { returnObjects: true }) as any).map((reason: string, idx: number) => (
              <MenuItem key={idx} value={reason}>
                {reason}
              </MenuItem>
            ))}
          </TextField>

          {selectedReason === "Other" && (
            <TextField
              fullWidth
              label={t("reportDialog.enterReasonLabel")}
              multiline
              rows={3}
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setIsReportDialogOpen(false)}>
            {t("reportDialog.cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={() => handleReportSubmit(videoDetails)}
            disabled={
              !selectedReason ||
              (selectedReason === "Other" && !customReason.trim())
            }
          >
            {t("reportDialog.submit")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Spam Model */}
      <Dialog open={isSpamDialogOpen} onClose={() => setIsSpamDialogOpen(false)}>
        <DialogTitle>{reported ? t('removeSpam') : t('reportSpam')}</DialogTitle>
        <DialogContent>
          {reported ? (
            <Typography>{t('removeReportConfirmation')}</Typography>
          ) : (
            <TextField
              label={t('enterReason')}
              fullWidth
              multiline
              rows={4}
              value={spamMessage}
              onChange={(e) => setSpamMessage(e.target.value)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsSpamDialogOpen(false)}>{t('cancel')}</Button>
          <Button
            onClick={handleSpam}
            color="primary"
            disabled={!reported && !spamMessage.trim()} // Disable if no message when reporting
          >
            {reported ? t('remove') : t('submit')}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default ShortVideoFeed;
